<template>
  <div>
    <SetPopup ref="confirm" />
    <MaterialIndexForm v-if="formReady" :param="param" :title="title" :is-edit="isEdit" save-label="저장" @save="save" @cancel="cancle" />
  </div>
</template>
<script>
import * as materialIndex from '@/assets/grid/materialIndex';
import { mapState, mapMutations } from 'vuex';
import { insertSubsMaster, updateSubsMaster, subsMasterDetail } from 'api/subIndex/subIndex';
import _ from 'lodash';
import SetPopup from '@/components/SetPopup.vue';
import MaterialIndexForm from './MaterialIndexForm.vue';
export default {
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      id: '',
      settings: materialIndex,
      param: {},
      originalParam: {},
      formReady: false,
    };
  },
  computed: {
    ...mapState('common', ['code']),
    ...mapMutations('member', ['SET_USER_INFO']),
    isEdit() {
      return !!(this.data && this.data.rmav);
    },
    title() {
      return this.isEdit ? '물질 인덱스 상세' : '물질 인덱스 등록';
    },
    tabCode() {
      return this.isEdit ? 'materialIndexDetail' : 'materialIndexAdd';
    },
    parentTabCode() {
      return this.isEdit ? 'STMGMT' : 'SAMGMT';
    },
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP']),
    ...mapMutations('menu', ['REMOVE_SELECT_MENU', 'SET_SELECT_MENU_TAB_BY_CODE']),
    openPopup(text, closable, cb) {
      this.SET_POPUP({
        title: '알림',
        width: 300,
        closable,
        text,
      });
      this.$refs.confirm.openPopup(cb);
    },
    cancle() {
      this.openPopup('취소 하시겠습니까?', true, () => {
        this.REMOVE_SELECT_MENU(this.tabCode);
        this.SET_SELECT_MENU_TAB_BY_CODE(this.parentTabCode);
      });
    },
    save() {
      if (this.isEdit && _.isEqual(this.param, this.originalParam)) {
        this.openPopup('변경 내역이 없습니다', false);
        return;
      }
      this.openPopup('저장 하시겠습니까?', true, () => {
        this.param.memberId = this.id;
        const payload = { ...this.param };
        _.each(this.settings.cycleFields, key => {
          if (payload[key] === '해당없음') payload[key] = '';
        });
        const api = this.isEdit ? updateSubsMaster : insertSubsMaster;
        api(payload)
          .then(() => {
            this.openPopup('저장 되었습니다', false, () => {
              this.REMOVE_SELECT_MENU(this.tabCode);
              this.SET_SELECT_MENU_TAB_BY_CODE(this.parentTabCode);
            });
          })
          .catch(() => {
            this.openPopup('관리자에게 문의하세요', false);
          });
      });
    },
    setData() {
      const obj = {};
      _.each(this.settings.columns, v => {
        if (_.includes(this.settings.ynFields, v.key)) {
          obj[v.key] = 'N';
        } else if (_.includes(this.settings.cycleFields, v.key)) {
          obj[v.key] = '해당없음';
        } else {
          obj[v.key] = '';
        }
      });
      obj.gc_analy_yn = 'Y'; // GC분석가능여부: Y=가능(기본), N=불가
      this.param = obj;
      this.formReady = true;
    },
    async loadData() {
      try {
        const res = await subsMasterDetail(this.data.rmav);
        const items = (res.data && res.data.data) || {};
        const obj = {};
        _.each(this.settings.columns, v => {
          const key = v.key;
          const val = items[key];
          if (_.includes(this.settings.ynFields, key)) {
            obj[key] = val === 'Y' ? 'Y' : 'N';
          } else if (_.includes(this.settings.cycleFields, key)) {
            obj[key] = val || '해당없음';
          } else {
            obj[key] = val == null ? '' : val;
          }
        });
        // GC분석가능여부: Y=가능(기본), N=불가. 불가 마커(레거시 '1','O' 포함)는 'N', 그 외는 'Y'로 정규화
        obj.gc_analy_yn = ['N', '1', 'O'].includes(items.gc_analy_yn) ? 'N' : 'Y';
        if (items.idx != null) obj.idx = items.idx;
        this.param = obj;
        this.originalParam = _.cloneDeep(obj);
        this.formReady = true;
      } catch (err) {
        this.error = err.message;
      }
    },
  },
  components: {
    SetPopup,
    MaterialIndexForm,
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    if (this.isEdit) {
      this.loadData();
    } else {
      this.setData();
    }
  },
};
</script>
